import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useAppInstallBanner } from '@/hooks/useAppInstallBanner';
import { analytics } from '@/lib/analytics';

export function AppInstallBanner() {
  const { shouldShow, dismiss, onInstallClick } = useAppInstallBanner();
  const hasTrackedShown = useRef(false);

  useEffect(() => {
    if (shouldShow && !hasTrackedShown.current) {
      hasTrackedShown.current = true;
      analytics.appBannerShown();
    }
  }, [shouldShow]);

  if (!shouldShow) return null;

  return (
    <div
      className={cn(
        'fixed bottom-[68px] left-2 right-2 z-30',
        'glass border border-border rounded-xl',
        'flex items-center gap-3 px-3 py-2.5',
        'animate-fade-in'
      )}
    >
      {/* App icon */}
      <img
        src="/android-chrome-192x192.png"
        alt="Bar Guide"
        className="h-8 w-8 rounded-lg flex-shrink-0"
      />

      {/* Text */}
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold text-[var(--color-text)] leading-tight">
          Get Bar Guide
        </div>
        <div className="text-xs text-[var(--color-muted)] leading-tight">
          Specials &amp; events on the go
        </div>
      </div>

      {/* Install CTA */}
      <Link
        to="/download"
        onClick={() => {
          onInstallClick();
          analytics.appBannerClicked();
        }}
        className={cn(
          'flex-shrink-0 px-4 py-1.5 rounded-lg text-sm font-medium',
          'bg-accent-primary text-black',
          'hover:bg-accent-primary-hover hover:shadow-glow',
          'transition-all duration-200 ease-out',
          'active:scale-[0.98]'
        )}
      >
        Install
      </Link>

      {/* Dismiss */}
      <button
        onClick={() => {
          dismiss();
          analytics.appBannerDismissed();
        }}
        className="flex-shrink-0 p-1 text-[var(--color-muted)] hover:text-[var(--color-text)] transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
